import { buildHackySchoolPageUrl } from '../buildHackySchoolPageUrl';
import { SchoolDetails } from '../types/SchoolDetails';
import { SchoolSuggestion } from '../../search/types/typeaheadSuggestions';
import { Svg } from '../Svg';
import { LoadingEllipsis } from '../LoadingEllipsis';

export const MAX_PHOTOS = 5;

const getSchoolInfoPageUrl = function (school: SchoolSuggestion) {
    if (school.schoolInfoPagePath) {
        return baseFrontURL + school.schoolInfoPagePath;
    }

    return buildHackySchoolPageUrl(school.schoolId);
};

export const SchoolCard = function SchoolCard({ school, schoolDetails = null }:
    {
        school: SchoolSuggestion | 'LOADING',
        schoolDetails?: SchoolDetails | 'LOADING' | null,
    }) {
    const renderContent = function () {
        if (school === 'LOADING') {
            return <LoadingEllipsis className="loading-school-card"/>;
        }

        return <a href={getSchoolInfoPageUrl(school)}>
            <div className="school-location">
                <span className="location"><Svg icon="location" />{school.cityName}, {school.stateCode}</span>
            </div>
            <h3 className="school-name">
                {school.schoolName}
            </h3>
            { renderTeacherPhotos() }
        </a>;
    };

    const renderTeacherPhotos = function () {
        if (schoolDetails === 'LOADING') {
            return <LoadingEllipsis className="loading-teachers" />;
        }
        if (schoolDetails?.numPostedProjects) {
            return (
                <div>
                    <div className="teachers"> {
                        (schoolDetails.teacherPhotos ?? []).slice(0, MAX_PHOTOS).map((teacherPhoto, index) =>
                            <div className="teacher" key={teacherPhoto.photoURL}>
                                <div className="pfp-container">
                                    <img className="pfp" src={teacherPhoto.photoURL} alt={teacherPhoto.name} key={index} />
                                </div>
                            </div>,
                        )
                    } </div>
                    { renderNumTeachersUse() }
                </div>
            );
        }

        return (
            <div className="no-active-teachers">
                <p className="founding-supporter"><b>Become a Founding Supporter</b><br />Proactively keep teachers stocked with supplies!</p>
            </div>
        );
    };

    const renderNumTeachersUse = function () {
        if (schoolDetails === 'LOADING') {
            return null;
        }

        if (schoolDetails?.numEligibleTeachersWithProjects) {
            if (schoolDetails.numEligibleTeachersWithProjects === 1) {
                return <div>1 teacher uses DonorsChoose</div>;
            }
            return <div>{schoolDetails.numEligibleTeachersWithProjects} teachers use DonorsChoose</div>;
        }
    };

    return <div className="school-card">
        { renderContent() }
    </div>;
};
